import React from "react"

const GiftCost = () => {
  const title = `贈与登記の費用例`
  const content = `弊所で贈与による所有権移転登記をご依頼いただいた場合の費用例を下記にご紹介しましたのでご参照ください。
ただし、想定事例限定のものとなりますので、個別の御見積については、お気軽にお問い合わせ下さい。
`

  return (
    <div className="detail">
      <div className="detail__content">
        <h2>{title}</h2>
        <p>{content}</p>
        <div className="massyo__cost__exam">
          <h3>想定条件</h3>
          <ul>
            <li>所有権移転登記：１件</li>
            <li>不動産：土地１筆・建物１戸</li>
            <li>固定資産税評価額合計：　２,０００万円</li>
            <li>登記完了後の登記事項証明書: 　土地・建物 各１通</li>
            <li>贈与者・受贈者事務所来所等出張なしの手続</li>
            <li>贈与証書作成</li>
          </ul>
          <h4>以上の条件による登記費用例</h4>
          <p>約500,000円程度</p>
          <p>（報酬・実費・消費税（10%）込）</p>
        </div>
      </div>
    </div>
  )
}

export default GiftCost
